import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css';
import { Routes, Route } from 'react-router-dom';
import { GrPrevious } from 'react-icons/gr';
import { AiOutlineDown } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { useState } from 'react';

/* 레이아웃 */
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';

/* 컴포넌트 */
import Header from '../components/Header';
import Footer from '../components/Footer';

/* 아이콘 */
import { BsSuitHeart, BsSuitHeartFill } from "react-icons/bs";

const Experience = () => {
    const [bookmark1, setBookmark1] = useState(false);
    const [bookmark2, setBookmark2] = useState(false);
    const [bookmark3, setBookmark3] = useState(false);
    const [bookmark4, setBookmark4] = useState(false);
    const [bookmark5, setBookmark5] = useState(false);
    const [bookmark6, setBookmark6] = useState(false);

    const handleBookmark1 = () => {
        setBookmark1(!bookmark1);
    };
    const handleBookmark2 = () => {
        setBookmark2(!bookmark2);
    };
    const handleBookmark3 = () => {
        setBookmark3(!bookmark3);
    };
    const handleBookmark4 = () => {
        setBookmark4(!bookmark4);
    };
    const handleBookmark5 = () => {
        setBookmark5(!bookmark5);
    };
    const handleBookmark6 = () => {
        setBookmark6(!bookmark6);
    };
    return (
        <>
            {/* 헤더 */}
            <Header />
            {/* 컨텐츠 */}
            <Routes>
                <Route path='/' element={
                    <>
                        <div className='Eslide'>
                            <Link to='/Main'><GrPrevious className='Eprev' /></Link>
                            <p className='ex_name'>체험단</p>
                            <p className='me'>신청현황</p>
                        </div>
                        <Container className='Ebox_wrap'>
                            <Row className='Ebox Ebox1'>
                                <div className='Ebox_img'>
                                    <Link to='/Experience01' className='shop_img1 shop_img'>
                                        <div  
                                            onClick={handleBookmark1}
                                        >
                                            {bookmark1 ? (
                                                <BsSuitHeart className="BsSuitHeartIcon heart" />
                                                
                                            ) : (
                                                <BsSuitHeartFill className="BsSuitHeartFillIcon heart" />
                                            )}
                                        </div>
                                    </Link>
                                    <div className='shop_img2 shop_img' onClick={handleBookmark2}>
                                        {bookmark2 ? (
                                            <BsSuitHeartFill className="BsSuitHeartFillIcon heart" />
                                        ) : (
                                            <BsSuitHeart className="BsSuitHeartIcon heart" />
                                        )}
                                    </div>
                                </div>
                                <div className='Ebox_content'>
                                    <Link to='/Experience01'>
                                        <p className='EdayWrap'><em className='Eday'>5일 남음</em><br />[강남] 르블라썸<br /><em className='Ehair'>펌 or 염색 or 클리닉</em></p>
                                    </Link>
                                    <p><em className='Eday'>10일 남음</em><br />[강남] 더부띠끄<br /><em className='Ehair'>염색</em></p>
                                </div>
                            </Row>
                            <Row className='Ebox Ebox2'>
                                <div className='Ebox_img'>
                                    <div className='shop_img3 shop_img' onClick={handleBookmark3}>
                                        {bookmark3 ? (
                                            <BsSuitHeartFill className="BsSuitHeartFillIcon heart" />
                                        ) : (
                                            <BsSuitHeart className="BsSuitHeartIcon heart" />
                                        )}
                                    </div>
                                    <div className='shop_img4 shop_img' onClick={handleBookmark4}>
                                        {bookmark4 ? (
                                            <BsSuitHeartFill className="BsSuitHeartFillIcon heart" />
                                        ) : (
                                            <BsSuitHeart className="BsSuitHeartIcon heart" />
                                        )}
                                    </div>
                                </div>
                                <div className='Ebox_content'>
                                    <p><em className='Eday'>3일 남음</em><br />[압구정] 비하인드헤어<br /><em className='Ehair'>클리닉</em></p>
                                    <p><em className='Eday'>5일 남음</em><br />[강남] 살롱드라피네<br /><em className='Ehair'>시술 중 택1</em></p>
                                </div>
                            </Row>
                            <Row className='Ebox Ebox3'>
                                <div className='Ebox_img'>
                                    <div className='shop_img5 shop_img' onClick={handleBookmark5}>
                                        {bookmark5 ? (
                                            <BsSuitHeartFill className="BsSuitHeartFillIcon heart" />
                                        ) : (
                                            <BsSuitHeart className="BsSuitHeartIcon heart" />
                                        )}
                                    </div>
                                    <div className='shop_img6 shop_img' onClick={handleBookmark6}>
                                        {bookmark6 ? (
                                            <BsSuitHeartFill className="BsSuitHeartFillIcon heart" />
                                        ) : (
                                            <BsSuitHeart className="BsSuitHeartIcon heart" />
                                        )}
                                    </div>
                                </div>
                                <div className='Ebox_content'>
                                    <p><em className='Eday'>15일 남음</em><br />[삼성역] 이든헤어<br /><em className='Ehair'>1인 시술 중 택1</em></p>
                                    <p><em className='Eday'>9일 남음</em><br />[성수] 위에뜰<br /><em className='Ehair'>탈색</em></p>
                                </div>
                            </Row>
                        </Container>
                    </>
                } />
            </Routes>
            {/* 푸터 */}
            <Footer />
        </>
    )
};

export default Experience;